<template>

  <div class="row">
    <div class="col col-md-12 text-left">
      <h6 class="mb-1">
        {{ $props.item.regexNome }}
      </h6>
      <p class="text-secondary textoResumo d-flex w-100 justify-content-between">
        <small>📧 {{ formatDateTime($props.item.data) }} | PIX {{ $props.item.regexComprovante && $props.item.regexComprovante !== "" ? "(" + $props.item.regexComprovante + ")" : "" }} | <span class=""><b>Valor: {{ $props.item.regexValor
        }}</b></span>
          | <span>Data: {{ $props.item.regexData }}</span> | {{ $props.item.regexTipo }}: {{ ($props.item.regexTipo ==
            "CPF" ?
            $props.item.regexCpf : $props.item.regexCnpj) }}</small>
      </p>
      <div class="d-flex" style="margin-top:4px" v-if="$props.propView == 'full'">
        <div>👨‍💼</div>
        <div v-if="$props.item.status == 'NOVO'">
          <button type="button" class="btn btn-warning btn-sm text-white"
            style="zoom:0.8;padding:0px; padding-left: 2px; padding-right: 2px;"
            @click="$emit('lancarPlanoCliente', $props.item)">criar
            plano</button>
        </div>
        <div v-if="$props.item.status == 'CRIADO'">
          <p class="text-secondary m-0">
            <small>{{ $props.item.planoUsuario.usuario.site }} | {{ $props.item.planoUsuario.usuario.email }}</small>
          </p>
        </div>
      </div>
      <div v-if="$props.item.status == 'CRIADO' && $props.propView == 'full'" class="d-flex">
        <div>📔</div>
        <div>
          <p class="text-secondary m-0">
            <small>Lançamento: {{ formatDateTime($props.item.planoUsuario.dataLancamento) }} | {{
              $props.item.planoUsuario.plano.nome }} | Período: {{ formatDate($props.item.planoUsuario.dataInicio) }} -
              {{ formatDate($props.item.planoUsuario.dataFim) }} ({{
                $props.item.planoUsuario.plano.duracao
              }}
              dias){{ $props.item.planoUsuario.usuarioCriacao ? " | " + $props.item.planoUsuario.usuarioCriacao.nome : "" }}</small>
          </p>
        </div>
      </div>
      

      <pre v-if="false">
        {{ $props.item }}
      </pre>

    </div>
  </div>

</template>

<script>
import util from "../includes/util.js";

export default {
  name: "ListPayAdminItem",
  components: {},
  props: {
    item: { type: Object, default: () => { } },
    propView: { type: String, default: "full" },
  },
  methods: {
    retornaSite() {
      return this.$site;
    },
    formatDate(data) {
      if (data == "-") {
        return data;
      }
      return util.formatDate(data);
    },
    formatDateTime(data) {
      return util.formatDateTime(data);
    },
  },
  mounted() {
  },
  data: function () {
    return {
    };
  },
};
</script>